import React from "react";
import useCaregiver from "../hooks/useCaregiver";
import useMixin from "../hooks/useMixin";
import { isLoading } from "../Loading";
import { STRINGS } from "../strings";
import { AppState } from "../system/AppState";
import { translate } from "../translate";
import LoadingScaffold from "./LoadingScaffold";
import SettingsHelpScreen from "./SettingsHelpScreen";

interface Props {
  appState: AppState;
  getAnomalies: (noEncode: boolean) => Promise<string>;
  onClickChatSupport: () => void;
  onClickGoBack: () => void;
}

const SettingsHelpActivity = (props: Props) => {
  const caregiver = useCaregiver(props.appState);
  const { appAgenciesState } = useMixin(props.appState);

  if (isLoading(caregiver) || isLoading(appAgenciesState)) {
    return <LoadingScaffold title={translate(STRINGS.HELP)} onClickGoBack={props.onClickGoBack} />;
  }

  return (
    <SettingsHelpScreen
      caregiver={caregiver}
      agencies={appAgenciesState.agencies}
      getAnomalies={props.getAnomalies}
      onClickChatSupport={props.onClickChatSupport}
      onClickGoBack={props.onClickGoBack}
    />
  );
};

export default React.memo(SettingsHelpActivity);
